module.exports = __webpack_public_path__ + "images/avatars/male/12.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/12.png
// module id = wX/j
// module chunks = 51